import React, { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
import Select from 'react-select';
import { Post } from '../../../../function/Koneksi';

const ModalMasterDisposisi = ({ data, optionData, setAlert, isOpen, setIsOpen, setStatusRefresh}) => {

	const frmDex = {
		uuid: '',
		uuid_pengaturan: '',
		uuid_jabatan_perangkat: '',
		level: '',
	}

	const initFormData = {
		masterDetail: optionData.masterDetail,
		frmJp: optionData.frmJp,
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [dt, setDt] = useState(data ? data : frmDex)
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}
		// console.log(data);
		// console.log(optionData);
		setDt(data ? data : frmDex)
		setFormData(data ? {
			...initFormData,
			status: optionData.status,
			jpStat: optionData.jpStat,
		} : initFormData)
	}, [isOpen])


	const changeSelectValue = (e, dtVal, formVal) => {
		if(e){
			setDt({
				...dt,
				[dtVal]: e.value,
			})
	
			setFormData({
				...formData,
				[formVal]: e,
			})
		}
		else{
			setDt({
				...dt,
				[dtVal]: '',
			})
	
			setFormData({
				...formData,
				[formVal]: null,
			})
		}
	};

	const changeInputText = (e, fld) => {
		setDt({
			...dt,
			[fld]: e.target.value,
		})
	};

	const simpan = (e) => {
		e.preventDefault();
		setAlert({
			loadingPreview: true
		})

		let bodyRaw = {
			...dt,
			uuid_pengaturan: formData.masterDetail.uuid,
		}

		let psn = "";
		let resstat = 204;
		let metode = "create";
		if (bodyRaw.uuid === "") {
			psn = "Tambah";
			resstat = 201;
			bodyRaw.uuid = null;
		} else {
			psn = "Ubah";
			resstat = 200;
			metode = "update";
		}
		
		if(formData.jpStat){
			Post("pengaturan-disposisi/detail/" + metode, bodyRaw.uuid, bodyRaw,res => {
				console.log('respon simpan')
				console.log(res)
				setFormData({
					...formData,
					status: {
						...formData.status,
						btnForm: false,
						form: false,
					}
				})
				setIsOpen(false)
				if (res.status === resstat) {
					setAlert({
						loadingPreview: false
					})

					const alertData = {
						show: true,
						basicType: "success",
						basicTitle: "Data Detail Disposisi Surat",
						pesanAlert: "Berhasil " + psn + " Data",
						successAlert: true,
					}
					setAlert(alertData)
				} else if(res.status === 422) {
					setAlert({
						loadingPreview: false
					})

					const alertData = {
						show: true,
						basicType: "warning",
						basicTitle: "Data Detail Disposisi Surat",
						pesanAlert: res.data.message,
					}
					setAlert(alertData)
				} else {
					setAlert({
						loadingPreview: false
					})

					const alertData = {
						show: true,
						basicType: "danger",
						basicTitle: "Data Detail Disposisi Surat",
						pesanAlert: "Gagal " + psn + " Data"
					}
					setAlert(alertData)
				}
	
				// Refresh list
				setStatusRefresh(true)
			});
		}
		else{
			setAlert({
				loadingPreview: false
			})

			const alertData = {
				show: true,
				basicType: "warning",
				basicTitle: "Data Detail Disposisi Surat",
				pesanAlert: "Data tidak lengkap!"
			}
			setAlert(alertData)
		}
	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={true}
			style={{
				maxwidth: 'unset'
			}}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				onSubmit={simpan}
			>
				<div
					onMouseDown={(e) => {
						let slider = document.querySelector('.card-scrollable');
						setDraggable({
							isDown: true,
							startY: e.pageY - slider.offsetTop,
							scrollUp: slider.scrollTop,
						})
					}}
					onMouseLeave={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseUp={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseMove={(e) => {
						e.preventDefault();

						let slider = document.querySelector('.card-scrollable');

						if (!draggable.isDown) {
							return;
						}

						const y = e.pageY - slider.offsetTop;
						const startY = draggable.startY;
						const walk = y - startY;
						slider.scrollTop = draggable.scrollUp - walk;
					}}
				>
				<div className="modal-header">
					<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Detail Disposisi Surat {formData.masterDetail?formData.masterDetail.nama:''}</h5>
				</div>
				<div className="modal-body">
					<input
						className="form-control"
						id="uuid"
						type="hidden"
						placeholder=""
						defaultValue={dt.uuid}
					/>
					<FormGroup className="row">
						<Label
						className="col-sm-3 col-form-label"
						htmlFor="inputEmail3"
						>
						Jabatan Perangkat{" "}
						</Label>
						<Col sm="9">
						<Select
							classNamePrefix="select"
							onChange={e => {
								changeSelectValue(e,'uuid_jabatan_perangkat','jpStat');
							}}
							defaultValue={formData.jpStat}
							value={formData.jpStat}
							name="penduduk"
							options={formData.frmJp}
							placeholder="Pilih Jabatan Perangkat"
							isClearable
						/>
						</Col>
					</FormGroup>
					<FormGroup className="row">
						<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
							Level
						</Label>
						<Col sm="9">
							<input
								data-testid="level"
								name="level"
								className="form-control"
								id="level"
								type="text"
								placeholder="Masukkan Level Disposisi"
								defaultValue={dt.level}
								required
								pattern="\d{1,16}"
                        		minLength={1}
                        		maxLength={2}
								onChange={e => changeInputText(e, "level")}
							/>
						</Col>
					</FormGroup>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						className="btn btn-warning"
						onClick={() => {
							// Tutup modal
							setFormData({
								...formData,
								status: {
									...formData.status,
									form: false,
								}
							})
							setIsOpen(false)
						}}
					>
						Tutup
					</button>
					<button
						data-testid="btnSubmitCreate"
						type="submit"
						className="btn btn-primary-custom"
						disabled={formData.status.btnForm}
					>
						Simpan
					</button>
				</div>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalMasterDisposisi;
